var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"collapse"},[_c('div',{staticClass:"flex-between"},[_c('h3',{staticClass:"collapse-title"},[_vm._v("注意事项")]),_c('a',{staticClass:"collapse-btn",on:{"click":_vm.onCollapse}},[_vm._v("收起/展开")])]),_c('div',{style:({
      height: _vm.isCollapse ? '130px' : 'auto',
      overflow: _vm.isCollapse ? 'hidden' : 'auto'
    }),domProps:{"innerHTML":_vm._s(_vm.data)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }